import { SVGProps } from 'react';

const GroupBookingSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="63"
      viewBox="0 0 77 63"
      fill="none"
      {...props}
    >
      <g opacity="0.2">
        <path
          d="M36.4062 67.9918L16.3154 68.3569C14.3998 68.3917 12.8186 66.867 12.7838 64.9514L12.2851 37.5084C12.2663 36.4747 12.7095 35.4865 13.494 34.8131L23.0989 26.5682C24.3375 25.505 26.1497 25.4491 27.4515 26.4339L37.9384 34.3677C38.7875 35.01 39.2946 36.0067 39.3139 37.0712L39.8117 64.4602C39.8465 66.3758 38.3218 67.957 36.4062 67.9918Z"
          fill="#444444"
        />
        <path
          d="M69.9298 50.8654L51.9466 20.1161C51.247 18.9207 50.0371 18.1126 48.6663 17.9245L31.7263 15.5954C29.623 15.3055 27.6019 16.5207 26.8745 18.5148L21.2229 33.9758C20.7611 35.2386 20.8868 36.6414 21.5664 37.8012L39.5847 68.6133C40.8433 70.7641 43.6072 71.4864 45.7565 70.23L68.3132 57.0372C70.464 55.7787 71.1883 53.0162 69.9298 50.8654ZM35.4805 29.7954C33.1655 30.1424 31.0062 28.546 30.6592 26.2311C30.3119 23.9143 31.9083 21.7549 34.2233 21.4079C36.5401 21.0607 38.6976 22.6574 39.0449 24.9741C39.3919 27.2891 37.7973 29.4482 35.4805 29.7954Z"
          fill="url(#paint0_linear_5632_111168)"
        />
        <path
          d="M37.4077 38.4403C34.5948 38.862 32.6562 41.4841 33.0779 44.297C33.4995 47.11 36.1216 49.0485 38.9346 48.6269C41.7475 48.2053 43.686 45.5831 43.2644 42.7702C42.8428 39.9573 40.2207 38.0187 37.4077 38.4403ZM38.4638 45.486C37.3855 45.6477 36.3803 44.9046 36.2187 43.8263C36.0571 42.748 36.8002 41.7428 37.8785 41.5812C38.9568 41.4196 39.962 42.1627 40.1236 43.241C40.2852 44.3193 39.5421 45.3244 38.4638 45.486Z"
          fill="white"
        />
        <path
          d="M54.5444 42.4633C51.7315 42.8849 49.793 45.5071 50.2146 48.32C50.6362 51.1329 53.2584 53.0715 56.0713 52.6499C58.8842 52.2282 60.8228 49.6061 60.4011 46.7931C59.9795 43.9802 57.3574 42.0417 54.5444 42.4633ZM55.6005 49.509C54.5222 49.6706 53.5171 48.9275 53.3554 47.8492C53.1938 46.7709 53.9369 45.7658 55.0152 45.6041C56.0935 45.4425 57.0987 46.1856 57.2603 47.2639C57.4219 48.3422 56.6788 49.3474 55.6005 49.509Z"
          fill="white"
        />
        <path
          d="M47.3686 33.4916L42.2442 57.0976C42.0198 58.1314 42.6759 59.1513 43.7097 59.3757L43.7097 59.3757C44.7434 59.6001 45.7634 58.944 45.9878 57.9103L51.1122 34.3043C51.3366 33.2705 50.6805 32.2506 49.6467 32.0261C48.6129 31.8017 47.593 32.4579 47.3686 33.4916Z"
          fill="white"
        />
        <path
          d="M37.15 16.993C37.4039 18.6874 37.304 20.3521 36.9055 21.9144C36.1851 24.7278 34.4962 27.2026 32.1612 28.9007C31.3789 28.2584 30.8229 27.3339 30.6611 26.2546C30.6417 26.1251 30.6277 25.9948 30.6214 25.867C31.9724 24.7578 32.9824 23.2749 33.517 21.6021C33.9292 20.3154 34.0595 18.9147 33.8457 17.4883C33.7607 16.9217 33.6255 16.3755 33.4445 15.8546C32.0414 11.7944 27.9037 9.18321 23.5022 9.84294C18.5359 10.5873 15.1119 15.2165 15.8565 20.1846C16.4624 24.2264 19.6406 27.2462 23.4799 27.8294L22.3149 31.0147C17.366 29.9854 13.3457 25.9736 12.5523 20.6799C11.5343 13.8879 16.2149 7.55672 23.0069 6.53868C29.5849 5.55272 35.7276 9.9085 37.037 16.3497C37.0798 16.5621 37.1176 16.7772 37.15 16.993Z"
          fill="#444444"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.9728 11.5609L55.9545 7.52777C56.6857 6.53874 58.0802 6.32972 59.0692 7.06091C60.0582 7.7921 60.2673 9.18661 59.5361 10.1756L56.5544 14.2087C55.8232 15.1978 54.4287 15.4068 53.4397 14.6756L53.4397 14.6756C52.4506 13.9444 52.2416 12.5499 52.9728 11.5609ZM62.5528 24.0777L67.2401 22.2929C68.3896 21.8553 69.6762 22.4323 70.1139 23.5817C70.5516 24.7312 69.9745 26.0178 68.8251 26.4555L64.1378 28.2403C62.9883 28.678 61.7017 28.101 61.264 26.9515C60.8263 25.8021 61.4033 24.5154 62.5528 24.0777Z"
          fill="url(#paint1_linear_5632_111168)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1094 37.9239L6.20791 36.8599C5.00594 36.599 4.24307 35.4131 4.50399 34.2111C4.76492 33.0091 5.95082 32.2462 7.15279 32.5072L12.0543 33.5712C13.2562 33.8321 14.0191 35.018 13.7582 36.22C13.4972 37.422 12.3113 38.1848 11.1094 37.9239ZM13.8711 50.8841L9.29283 52.9324C8.17011 53.4347 6.85277 52.9318 6.35046 51.8091C5.84816 50.6864 6.3511 49.369 7.47382 48.8667L12.0521 46.8184C13.1748 46.3161 14.4922 46.819 14.9945 47.9417C15.4968 49.0645 14.9938 50.3818 13.8711 50.8841Z"
          fill="url(#paint2_linear_5632_111168)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5632_111168"
          x1="13.2884"
          y1="28.6868"
          x2="55.795"
          y2="64.8502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DCF46B" />
          <stop offset="1" stopColor="#4498EE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5632_111168"
          x1="50.1182"
          y1="11.9025"
          x2="66.7498"
          y2="24.0532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DCF46B" />
          <stop offset="1" stopColor="#4498EE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5632_111168"
          x1="2.63517"
          y1="36.8892"
          x2="16.2243"
          y2="43.2371"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DCF46B" />
          <stop offset="1" stopColor="#4498EE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default GroupBookingSvg;
